import { GlobalStylesProps, Theme } from '@mui/system';

const baseStyles: GlobalStylesProps<Theme>['styles'] = {
  
}

export default baseStyles